export enum ESubscriptionWorkFlow {
	INAPP = 'inapp',
	MINIAPP = 'miniapp',
	MOBILE_OPERATOR = 'mobile_operator',
	ANOTHER_APPLICATION = 'another_application',
}